export const PaymentRequestType = {
    SEMESTRAL: 'SEMESTRAL',
    FINAL: 'FINAL',

    values: () => {
        return ['SEMESTRAL', 'FINAL'];
    },
};
